import React from 'react';
import MemorialPage from './MemorialPage';

export default function AddMemoryPage({ profileSlug: providedSlug }) {
  return <MemorialPage profileSlug={providedSlug} initialAddOpen />;
}
